import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { getContentType } from "../kyc/kyc_doc_upload_POI_manual/actions";
import { ApplicationPendingBlockedStatus } from "@voltmoney/schema";
import { nextStepCredStepper, uploadImageViaFetch, uploadToS3Bucket, uploadToS3BucketUpdate } from "../../configs/utils";
import { Platform } from "react-native";
import { ACTION } from "./types";
let _getPresignedUrlForAdditionalDocumentToUpload = undefined;
export const goToEmail = async (action, _datastore, { navigate }) => {
    console.warn("**** goToEmail action ****", action);
    await navigate(ROUTE.EMAIL_STATEMENT);
};
export const navigation = async (action, _datastore, { navigate }) => {
    console.warn("*** navigationAction props ***", action);
    const routeId = action.payload.routeId;
    await navigate(routeId);
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const goBackHeaderAction = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.KYC_STEPPER);
};
export const getPresignedUrlForAdditionalDocumentToUploadAction = async (action, _datastore, { network }) => {
    const documentType = action.payload.documentType;
    const applicationId = action.payload.applicationId;
    const currentStepId = action.payload.currentStepId;
    const getPresignedUrlForAdditionalDocumentToUploadResponse = await network.get(`${api.getPresignedUrlForAdditionalDocumentToUpload}${applicationId}/${documentType}/${currentStepId}`, {
        headers: await getAppHeader()
    });
    _getPresignedUrlForAdditionalDocumentToUpload = getPresignedUrlForAdditionalDocumentToUploadResponse?.data;
};
export const callAppeal = async ({ applicationId, currentStepId, documentType, _imageNameFrontImage, _imageNameBackImage, responseFrontSide, responseBackSide }, { network, navigate, setDatastore }) => {
    const appealRequestBody = {
        applicationId: applicationId,
        stepId: currentStepId,
        documentType: documentType,
        ..._imageNameFrontImage && {
            imageNameFrontImage: _imageNameFrontImage,
        },
        ..._imageNameBackImage && {
            imageNameBackImage: _imageNameBackImage
        }
    };
    let appealResponse = undefined;
    if ((responseFrontSide
        && responseBackSide)
        || (responseFrontSide?.status === 200
            && responseBackSide?.status === 200)) {
        appealResponse = await network.post(`${api.submitSupportDocuments}`, appealRequestBody, {
            headers: await getAppHeader()
        });
    }
    else if (responseFrontSide
        || responseFrontSide?.status === 200) {
        appealResponse = await network.post(`${api.submitSupportDocuments}`, appealRequestBody, {
            headers: await getAppHeader()
        });
    }
    if (appealResponse?.status === 200) {
        await setDatastore(ROUTE.SUPPORTING_DOCUMENT, 'supportingDocumentPage', {
            loading: true
        });
        const borrowerApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() }, async () => {
            return;
        });
        const applicationState = borrowerApplicationResponse?.data?.applicationState;
        const currentStep = borrowerApplicationResponse?.data?.currentStepId;
        const routeObj = await nextStepCredStepper(currentStep);
        if (applicationState === ApplicationPendingBlockedStatus.BLOCKED) {
            await navigate(ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN, {
                applicationState: ApplicationPendingBlockedStatus.BLOCKED
            });
        }
        else {
            await navigate(routeObj?.routeId, routeObj?.params);
        }
        await setDatastore(ROUTE.SUPPORTING_DOCUMENT, 'supportingDocumentPage', {
            loading: false
        });
    }
    else {
        await setDatastore(ROUTE.SUPPORTING_DOCUMENT, 'supportingDocumentPage', {
            loading: false
        });
    }
};
export const submitForApproval = async (action, _datastore, { network, navigate, setDatastore, showPopup }) => {
    console.warn('*** submit for approval ***', action);
    const applicationId = action?.payload?.applicationId;
    const documentType = action?.payload?.documentType;
    const currentStepId = action.payload.currentStepId;
    const frontFile = action?.payload?.frontValue;
    const backFile = action?.payload?.backValue;
    let _imageNameFrontImage = undefined;
    let _imageNameBackImage = undefined;
    let responseBackSide = undefined;
    let responseFrontSide = undefined;
    const uploadViaFetch = await uploadImageViaFetch();
    await setDatastore(ROUTE.SUPPORTING_DOCUMENT, 'supportingDocumentPage', {
        loading: true
    });
    let frontFileExtension = '';
    let backFileExtension = '';
    if (frontFile) {
        // eslint-disable-next-line no-prototype-builtins
        frontFileExtension =
            Platform.OS === 'web'
                ? frontFile.name.split('.').pop() :
                frontFile.hasOwnProperty('name')
                    ? frontFile.name.split('.').pop()
                    : frontFile.fileName.split('.').pop();
        console.log("frontFileExtension: ", frontFileExtension);
        _imageNameFrontImage = _getPresignedUrlForAdditionalDocumentToUpload?.imageNameFrontImage;
    }
    if (backFile) {
        // eslint-disable-next-line no-prototype-builtins
        backFileExtension = Platform.OS === 'web' ? backFile.name.split('.').pop() : backFile.hasOwnProperty('name') ? backFile.name.split('.').pop() : backFile.fileName.split('.').pop();
        _imageNameBackImage = _getPresignedUrlForAdditionalDocumentToUpload?.imageNameBackImage;
    }
    // upload file to s3 frontSide
    if (frontFile
        && _getPresignedUrlForAdditionalDocumentToUpload
        && _getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForFrontImage) {
        if (Platform.OS === 'web') {
            responseFrontSide = await network.put(`${_getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForFrontImage}`, frontFile, {
                headers: { 'Content-Type': getContentType(frontFileExtension) },
            });
        }
        if (Platform.OS != 'web') {
            if (uploadViaFetch) {
                uploadToS3BucketUpdate(`${_getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForFrontImage}`, frontFile, getContentType(frontFileExtension)).then((res) => {
                    responseFrontSide = res;
                    //check for backFileUpload
                    if (backFile
                        && _getPresignedUrlForAdditionalDocumentToUpload
                        && _getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForBackImage) {
                        uploadToS3BucketUpdate(`${_getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForBackImage}`, backFile, getContentType(backFileExtension)).then((res) => {
                            console.log('upload success: ', res);
                            responseBackSide = res;
                            //call appeal for both front and back file
                            callAppeal({
                                applicationId,
                                currentStepId,
                                documentType,
                                _imageNameFrontImage,
                                _imageNameBackImage,
                                responseFrontSide,
                                responseBackSide
                            }, {
                                network, navigate, setDatastore
                            });
                        }).catch((err) => {
                            showPopup({
                                type: 'FAILED',
                                title: 'Image upload failed',
                                subTitle: ' ',
                                ctaLabel: 'Try again',
                                primary: true,
                                ctaAction: {
                                    routeId: ROUTE.SUPPORTING_DOCUMENT,
                                    type: ACTION.UPLOAD_FAILED,
                                    payload: {},
                                },
                            });
                        });
                    }
                    else {
                        //call appeal without back file
                        callAppeal({
                            applicationId,
                            currentStepId,
                            documentType,
                            _imageNameFrontImage,
                            _imageNameBackImage,
                            responseFrontSide,
                            responseBackSide
                        }, {
                            network, navigate, setDatastore
                        });
                    }
                }).catch((err) => {
                    showPopup({
                        type: 'FAILED',
                        title: 'Image upload failed',
                        subTitle: ' ',
                        ctaLabel: 'Try again',
                        primary: true,
                        ctaAction: {
                            routeId: ROUTE.SUPPORTING_DOCUMENT,
                            type: ACTION.UPLOAD_FAILED,
                            payload: {},
                        },
                    });
                });
            }
            else {
                uploadToS3Bucket(`${_getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForFrontImage}`, frontFile, getContentType(frontFileExtension)).then((res) => {
                    responseFrontSide = res;
                    //check for backFileUpload
                    if (backFile
                        && _getPresignedUrlForAdditionalDocumentToUpload
                        && _getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForBackImage) {
                        uploadToS3Bucket(`${_getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForBackImage}`, backFile, getContentType(backFileExtension)).then((res) => {
                            console.log('upload success: ', res);
                            responseBackSide = res;
                            //call appeal for both front and back file
                            callAppeal({
                                applicationId,
                                currentStepId,
                                documentType,
                                _imageNameFrontImage,
                                _imageNameBackImage,
                                responseFrontSide,
                                responseBackSide
                            }, {
                                network, navigate, setDatastore
                            });
                        }).catch((err) => {
                            showPopup({
                                type: 'FAILED',
                                title: 'Image upload failed',
                                subTitle: ' ',
                                ctaLabel: 'Try again',
                                primary: true,
                                ctaAction: {
                                    routeId: ROUTE.SUPPORTING_DOCUMENT,
                                    type: ACTION.UPLOAD_FAILED,
                                    payload: {},
                                },
                            });
                        });
                    }
                    else {
                        //call appeal without back file
                        callAppeal({
                            applicationId,
                            currentStepId,
                            documentType,
                            _imageNameFrontImage,
                            _imageNameBackImage,
                            responseFrontSide,
                            responseBackSide
                        }, {
                            network, navigate, setDatastore
                        });
                    }
                }).catch((err) => {
                    showPopup({
                        type: 'FAILED',
                        title: 'Image upload failed',
                        subTitle: ' ',
                        ctaLabel: 'Try again',
                        primary: true,
                        ctaAction: {
                            routeId: ROUTE.SUPPORTING_DOCUMENT,
                            type: ACTION.UPLOAD_FAILED,
                            payload: {},
                        },
                    });
                });
            }
        }
    }
    // upload file to s3 backSide
    if (backFile
        && _getPresignedUrlForAdditionalDocumentToUpload
        && _getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForBackImage) {
        if (Platform.OS === 'web') {
            responseBackSide = await network.put(`${_getPresignedUrlForAdditionalDocumentToUpload.preSignedUrlForBackImage}`, backFile, {
                headers: { 'Content-Type': getContentType(backFileExtension) },
            });
            console.log("responseBackSide: ", responseBackSide);
        }
    }
    if (Platform.OS === 'web') {
        await callAppeal({
            applicationId,
            currentStepId,
            documentType,
            _imageNameFrontImage,
            _imageNameBackImage,
            responseFrontSide,
            responseBackSide
        }, {
            network,
            navigate,
            setDatastore
        });
    }
};
